import React, { useState } from "react";
import { connect } from "react-redux";
import { Layout } from "../components/Layout";
import { Error, FieldDiv } from "../components/FieldDiv";
import { formErrorMessage } from "../store/reducers";
import { BigButton, Input } from "../components/styles";
import { Form } from "../components/Form";
import { Link } from "react-router-dom";

const _ForgottenPasswordForm = ({
    formErrorMessage,
    resetPassword,
    submit
}) => (
    <Layout>
        <Form
            onSubmit={e => {
                e.preventDefault();
                submit();
                resetPassword(e.target.email.value);
            }}
        >
            <FieldDiv>
                <Input type="email" placeholder="Email" name="email" />
            </FieldDiv>
            {formErrorMessage && (
                <FieldDiv>
                    <Error>{formErrorMessage}</Error>
                </FieldDiv>
            )}
            <FieldDiv>
                <BigButton>Reset password</BigButton>
            </FieldDiv>
        </Form>
    </Layout>
);

const dispatchActions = {
    resetPassword: email => ({
        type: "RESET_PASSWORD",
        email
    })
};

const mapState = state => ({
    formErrorMessage: formErrorMessage(state)
});

const ForgottenPasswordForm = connect(
    mapState,
    dispatchActions
)(_ForgottenPasswordForm);

const ForgottenPassword = () => {
    const [submitted, setSubmitted] = useState(false);
    const submit = () => setSubmitted(true);
    if (submitted) {
        return (
            <Layout>
                <h1>Thanks</h1>
                <p>
                    If an account exists with this email address, you should
                    receive an email with instructions to reset your password.
                </p>
                <div>
                    <Link to="/login">Login</Link>
                </div>
            </Layout>
        );
    }
    return <ForgottenPasswordForm submit={submit} />;
};

export { ForgottenPassword };



// WEBPACK FOOTER //
// ./src/pages/ForgottenPassword.js